export default "__VITE_ASSET__DON1RuP5__"